import fetchApi from 'components/utils/fetch_api'

const sessions = token => {
  return fetchApi('kb/users/sessions', { data: { token }, method: 'POST' })
}

export { sessions }
